import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { ShieldCheck } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

// Verify email ownership with a 6-digit code to link reserved team spots to this account
export const ClaimSpotBox = ({ text, onLinked }) => {
  const [sent, setSent] = useState(false);
  const [code, setCode] = useState('');
  const [busy, setBusy] = useState(false);
  const headers = { Authorization: `Bearer ${localStorage.getItem('codearena_token')}` };
  const run = async (fn) => {
    setBusy(true);
    try { const r = await fn(); toast.success(r.data.message); return r; }
    catch (e) { toast.error(e.response?.data?.detail || 'Something went wrong'); return null; }
    finally { setBusy(false); }
  };
  const send = async () => { if (await run(() => axios.post(`${API}/api/event-teams/claims/send-code`, {}, { headers }))) setSent(true); };
  const verify = async () => { if (await run(() => axios.post(`${API}/api/event-teams/claims/verify-code`, { code }, { headers }))) onLinked?.(); };
  return (
    <div className="p-4 rounded-lg border border-violet-200 bg-violet-50 space-y-3" data-testid="claim-spot-box">
      <p className="text-sm text-[#0A0A0A] flex items-start gap-2"><ShieldCheck size={16} className="text-violet-700 flex-shrink-0 mt-0.5" /> {text}</p>
      {!sent ? (
        <button onClick={send} disabled={busy} className="px-4 py-2 bg-violet-700 hover:bg-violet-800 text-white rounded text-sm font-semibold disabled:opacity-50" data-testid="claim-send-code-btn">Email me a verification code</button>
      ) : (
        <div className="flex gap-2">
          <input value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))} placeholder="6-digit code" inputMode="numeric"
            className="w-36 px-3 py-2 border border-violet-200 rounded text-sm tracking-[0.3em] text-[#0A0A0A]" data-testid="claim-code-input" />
          <button onClick={verify} disabled={busy || code.length !== 6} className="px-4 py-2 bg-violet-700 text-white rounded text-sm font-semibold disabled:opacity-50" data-testid="claim-verify-btn">Verify & link</button>
          <button onClick={send} disabled={busy} className="text-xs text-violet-700 font-semibold" data-testid="claim-resend-btn">Resend</button>
        </div>
      )}
    </div>
  );
};
